<form #projectForm="ngForm" (ngSubmit)="onSubmit(projectForm)" class="p-4 pb-0 h-100 flex flex-col gap-y-2">
  <h2 class="">Edit Project</h2>
  <div class="grow flex-col gap-y-2">
    <div class="flex space-x-6">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Project Name</mat-label>
        <input matInput name="name" [(ngModel)]="projectData.name" required>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Group Project</mat-label>
        <mat-select name="groupProject" [(ngModel)]="projectData.groupProject" required>
          <mat-option *ngFor="let group of groupProjects" [value]="group.id">{{ group.groupName }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select name="status" [(ngModel)]="projectData.status" required>
        <mat-option value="Active">Active</mat-option>
        <mat-option value="Completed">Completed</mat-option>
        <mat-option value="On Hold">On Hold</mat-option>
        <mat-option value="Cancelled">Cancelled</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="flex space-x-6">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="startDatePicker" name="startDate" [(ngModel)]="projectData.startDate" required>
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="endDatePicker" name="endDate" [(ngModel)]="projectData.endDate" required>
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Project Detail</mat-label>
      <textarea matInput name="detail" [(ngModel)]="projectData.detail"></textarea>
    </mat-form-field>

    <!-- Image Upload -->
    <div class="mb-3">
      <label>Project Image</label>
      <input
        type="file"
        accept="image/*"
        (change)="onFileSelected($event)"
        class="form-control"
      />
    </div>

    <!-- Image Preview -->
    <div *ngIf="previewImage" class="mb-3">
      <img [src]="previewImage" alt="Preview" width="150" height="150" class="rounded border">
    </div>
  </div>

  <div class="flex pt-2 pb-2 items-end justify-end space-x-4">
    <app-button-ui size="small" color="light" (click)="dialogRef.close()">Cancel</app-button-ui>
    <app-button-ui size="medium" type="submit">Update Project</app-button-ui>
  </div>
</form>
